//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      recordNumber: '沪ICP备15034889号-3',
    };
  },
  mounted() {
    const currentURL = window.location.href
    if (currentURL.includes('e-fp.cn')) {
      this.recordNumber = '沪ICP备15034889号-4'
    } else if (currentURL.includes('kaifapiao.com')) {
      this.recordNumber = '沪ICP备15034889号-5'
    } else {
      this.recordNumber = '沪ICP备15034889号-3'
    }
  },
}
